import React, { useEffect, useRef, useState } from "react";
import Esign from "../Esign";
import useToggle from "../../../../hooks/toggle";
import { selecteddocumentesign } from "../ReviewDocs";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getexternaldocuments, getSavedOfferDetails, VAaddendumPOST } from "../../../../api/transaction";
import { useReactToPrint } from 'react-to-print';
import { CSpinner } from "@coreui/react";
const VAaddendum = ()=>{
  const {id,user} : any = useParams()
  const componentRef = useRef();
    const [canvasmodal, setCanvasModal] = useToggle(false);
    const [loader,setloading] = useState(false)
    const [htmlContent, setHtmlContent] = useState("");
    const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
        offerid : "",
      document_name: "",
      image_base64: "",
      sign_role: 1
      })
    const[vaaddendum,setVAaddendum] = useState({
        offer_id: id,
        buyer  :"",
        seller   :"",
        property_locatedAt  :"",
        property_aggrement_date  :null,
        buyer1  :"",
        buyer1_date  :null,
        buyer2  :"",
        buyer2_date  :null,
        buyer3 :"",
        buyer3_date  :null,
        seller1 :"",
        seller1_date  :null,
        seller2  :"",
        seller2_date   :null,
        seller3  :"",
        seller3_date : null,
    })

           
    const printf = () => {
      handlePrint()
        // window.print()
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
     // @ts-ignore
     const val = useSelector((state) => state?.new?.signset)


     useEffect(()=>{
      if(val){
        if(user == "seller"){
          setVAaddendum({ ...vaaddendum, seller1: val })
        }
        if(user == "client"){
          setVAaddendum({ ...vaaddendum, buyer1: val })
        }
      }
      },[val])


 const send = async()=>{  
  setloading(true)
  if(user === "seller"){

    if(vaaddendum?.seller1){
      let res = await VAaddendumPOST(vaaddendum)
      if(res?.status == "success"){
        alert("Submitted Successfully")
    }
    else{
        alert("Something went wrong")
    }
    }
  }
  else if(user === "client"){
 
    if(vaaddendum?.buyer1){
      let res = await VAaddendumPOST(vaaddendum)
      if(res?.status == "success"){
        alert("Submitted Successfully")
    }
    else{
        alert("Something went wrong")
    }
    }
  }
  setloading(false)
}   
const [offerdetails,setOfferDetails]:any = useState({})
useEffect(()=>{
  (async function(){
    let offerdetails = await getSavedOfferDetails(id)

    setOfferDetails(offerdetails[0])
    const res =await getexternaldocuments(id,"va_addendum") 
    setVAaddendum({...vaaddendum,
      buyer  :res?.data?.buyer,
      seller   :res?.data?.seller,
      property_locatedAt  :res?.data?.property_locatedAt,
      property_aggrement_date  :res?.data?.property_aggrement_date,
      buyer1  :res?.data?.buyer1,
      buyer1_date  :res?.data?.buyer1_date,
      buyer2  :res?.data?.buyer2,
      buyer2_date  :res?.data?.buyer2_date,
      buyer3 :res?.data?.buyer3,
      buyer3_date  :res?.data?.buyer3_date,
      seller1 :res?.data?.seller1,
      seller1_date  :res?.data?.seller1_date,
      seller2  :res?.data?.seller2,
      seller2_date   :res?.data?.seller2_date,
      seller3  :res?.data?.seller3,
      seller3_date : res?.data?.seller3_date,

    })
  })()
},[])


    return (
        <>
      <table
    style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 20 }} ref={componentRef}
  >
    <tbody>
      <tr>
        <td>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td style={{ width: "90%" }}>
                  <img
                    style={{ width: 250 }}
                    src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                  />
                </td>
                <td>
                  <img
                    style={{ width: 30 }}
                    src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                    alt=""
                  />
                  <img
                    style={{ width: 50 }}
                    src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                    alt=""
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td style={{ paddingTop: 15 }}>
          <span style={{ fontSize: 20, fontWeight: 700 }}>
            VA Addendum to Purchase Agreement
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ paddingTop: 15 }}>
          <span style={{ fontSize: 20 }}>VA Escape Clause</span>
        </td>
      </tr>
      <tr>
        <td style={{ paddingBottom: 15 }}>
          <span style={{ fontWeight: 600 }}>
            (This addendum is legally binding, If not understood, seek legal
            advice.)
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span>
            This Addendum shall be an Integral part of the Purchase Agreement
            described below. Buyer and Seller agree that the Purchase Agreement
            Is expressly conditioned upon the terms of this addendum. To the
            extent that this modifies the Purchase Agreement, this Agreement
            controls.
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "10px 0px" }}>
          <span>
            <span style={{ fontWeight: 600, color: "#3b0083" }}>Buyer: </span>
            <input
            value={offerdetails?.leadName}
            // onChange={(e)=>setVAaddendum({...vaaddendum,buyer:e.target.value})}
              type="text"
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "90%"
              }}
            />
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "10px 0px" }}>
          <span>
            <span style={{ fontWeight: 600, color: "#3b0083" }}>Seller:</span>
            <input
            value={vaaddendum?.seller}
            onChange={(e)=>setVAaddendum({...vaaddendum,seller:e.target.value})}
              type="text"
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "90%"
              }}
            />
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "10px 0px" }}>
          <span>
            <span style={{ fontWeight: 600, color: "#3b0083" }}>
              Property Located at:{" "}
            </span>
            <input
              type="text"
              value={vaaddendum?.property_locatedAt}
              onChange={(e)=>setVAaddendum({...vaaddendum,property_locatedAt :e.target.value})}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "80%"
              }}
            />
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "10px 0px" }}>
          <span>
            <span style={{ fontWeight: 600, color: "#3b0083" }}>
              Purchase Agreement Dated:{" "}
            </span>
            <input
              type="date"
              value={vaaddendum?.property_aggrement_date }
              onChange={(e)=>setVAaddendum({...vaaddendum,property_aggrement_date  :e.target.value})}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "75%"
              }}
            />
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span style={{ paddingTop: 50, fontSize: 20, fontWeight: 600 }}>
            Veterans Administration (VA) Escape Clause
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span>
            It is expressly agreed that notwithstanding any other provisions of
            this contract, the purchaser shall not incur any penalty by
            forfeiture of earnest money deposit or otherwise be obligated to
            complete the purchase of the property described herein, if the
            contract purchase price or cost exceeds the reasonable value of the
            property established by the V.A. The purchaser shall, however, have
            the privilege and option of proceeding with the consummation of this
            contract without regard to the amount of reasonable value
            established by the V.A.
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td>
                  <span>
                    <img
                      
                      src={user==="client" ? (val || vaaddendum?.buyer1 ): vaaddendum?.buyer1 }
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "1px solid #3b0083",
                        width: "100px"
                      }}
                    />
                  </span>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "100%" }}>
                          <span>Buyer </span>
                        </td>
                        <td>
                        <input
              type="date"
              value={vaaddendum?.buyer1_date ? vaaddendum?.buyer1_date : (user === "client" && val || vaaddendum?.buyer1) ? new Date().toISOString().split('T')[0] : ""}
              onChange={(e)=>setVAaddendum({...vaaddendum,buyer1_date:e.target.value})}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "75%"
              }}
            />

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td>
                  <span>
                    <img
                      
                      src={user==="seller" ? (val || vaaddendum?.seller1 ): vaaddendum?.seller1 }
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "1px solid #3b0083",
                        width: "100px"
                      }}
                    />
                  </span>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "100%" }}>
                          <span>Seller</span>
                        </td>
                        <td>
                        <input    type="date"
              value={vaaddendum?.seller1_date ? vaaddendum?.seller1_date : (user === "seller" && val || vaaddendum?.seller1) ? new Date().toISOString().split('T')[0] : ""}
              onChange={(e)=>setVAaddendum({...vaaddendum,seller1_date:e.target.value})}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "75%"
              }}
            />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td>
                  <span>
                    <img
                
                      
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "1px solid #3b0083",
                        width: "99%"
                      }}
                    />
                  </span>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "100%" }}>
                          <span>Buyer </span>
                        </td>
                        <td>
                        <input     type="date"
              value={vaaddendum?.buyer2_date}
              onChange={(e)=>setVAaddendum({...vaaddendum,buyer2_date:e.target.value})}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "75%"
              }}
            />

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td>
                  <span>
                    <input
                      type="text"
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "1px solid #3b0083",
                        width: "99%"
                      }}
                    />
                  </span>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "100%" }}>
                          <span>Seller</span>
                        </td>
                        <td>
                        <input     type="date"
              value={vaaddendum?.seller2_date}
              onChange={(e)=>setVAaddendum({...vaaddendum,seller2_date:e.target.value})}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "75%"
              }}
            />

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td>
                  <span>
                    <input
                      type="text"
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "1px solid #3b0083",
                        width: "99%"
                      }}
                    />
                  </span>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "100%" }}>
                          <span>Buyer </span>
                        </td>
                        <td>
                        <input     type="date"
              value={vaaddendum?.buyer3_date}
              onChange={(e)=>setVAaddendum({...vaaddendum,buyer3_date:e.target.value})}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "75%"
              }}
            />

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td>
                  <span>
                    <input
                      type="text"
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "1px solid #3b0083",
                        width: "99%"
                      }}
                    />
                  </span>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "100%" }}>
                          <span>Seller</span>
                        </td>
                        <td>
                        <input     type="date"
              value={vaaddendum?.seller3_date}
              onChange={(e)=>setVAaddendum({...vaaddendum,seller3_date:e.target.value})}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "75%"
              }}
            />

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td style={{ paddingTop: 350 }}>
          <span>
            Other provisions: Earnest deposit to be delivered within (5)
            business days
          </span>
        </td>
      </tr>
    </tbody>
  </table>
  <React.Fragment>
<div className="d-flex align-items-center justify-content-end mb-2 mr-2">
    <button onClick={send} className="btn primaryColorBtn">Submit
    {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
    </button>
    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
    <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button> 
</div>
          </React.Fragment>

  <Esign
        canvasmodal={canvasmodal}
        setCanvasModal={setCanvasModal}
        htmlContent={htmlContent}
        setHtmlContent={setHtmlContent}
        selecteddocumentesign={selecteddocumentesign}
        setselectedDocumentEsign={setselectedDocumentEsign}
        type={"seller"}
      ></Esign>
        </>
    )
}

export default VAaddendum